import BaseRepository from '@/core/standard/BaseRepository';
import {axiosInstance} from '@/setup/axios/AxiosConfig';
import { GenericMethod } from "@/core/Types/IRepository";

class UserTimeTrackingService extends BaseRepository {
    public collection = 'rrhh/staff_schedule';
    public version = 'v1';

    public downloadTimeTrackingFile(params: GenericMethod) {
        return this.request({...params, url: 'download'});
    }

}

export default new UserTimeTrackingService(axiosInstance);
